import Vue from 'vue'

// axios
import axios from 'axios'
import { API_BASE } from '@/config'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: API_BASE,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
